import React, { Component } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-balham.css";
import "./ag-theme-ela.css";
import moment from "moment";

const DEFAULT_MIN_WIDTH_CELL = 10;
const DEFAULT_MAX_WIDTH_CELL = 800;

const defaultColDef = {
  resizable: true,
  sortable: true,
  filter: true,
  minWidth: DEFAULT_MIN_WIDTH_CELL,
  maxWidth: DEFAULT_MAX_WIDTH_CELL,
  cellStyle: {
    borderRight: "1px solid #ccc",
  },
};

const receivablesColumns = [
  { headerName: "Action", field: "actionCode", width: 100 },
  {
    headerName: "Transaction Date",
    field: "createDateTime",
    width: 120,
    valueFormatter: (params) => moment(params.value).format("MM/DD/YYYY"),
  },
  {
    headerName: "Check Date",
    field: "checkDate",
    width: 120,
    valueFormatter: (params) => moment(params.value).format("MM/DD/YYYY"),
  },
  { headerName: "Check Number", field: "checkNumber", width: 120 },
  { headerName: "Transfer From", field: "transferFrom", width: 120 },
  { headerName: "Transfer To", field: "transferTo", width: 120 },
  {
    headerName: "Amount",
    field: "amount",
    width: 150,
    cellStyle: { textAlign: "right" },
  },
];

export class WorkOrderJobNotesTableReceivables extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gridApiReady: false,
    };

    this.onGridReady = this.onGridReady.bind(this);
    this.adjustHeaderHeight = this.adjustHeaderHeight.bind(this);
    this.getRowClass = this.getRowClass.bind(this);
  }

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.setState({ gridApiReady: true });
    this.adjustHeaderHeight(params.api);
  };

  adjustHeaderHeight = (gridApi) => {
    window.requestAnimationFrame(() => {
      const allColumnHeaders = document.querySelectorAll(
        ".ag-header-cell-text"
      );
      let maxHeight = 0;
      allColumnHeaders.forEach((header) => {
        if (header.parentElement.clientHeight > maxHeight) {
          maxHeight = header.parentElement.clientHeight;
        }
      });
      maxHeight += 10;
      gridApi.setHeaderHeight(maxHeight);
    });
  };

  getRowClass = (params) => {
    return params.node.rowIndex % 2 === 0
      ? "custom-even-row"
      : "custom-odd-row";
  };

  render() {
    const gridOptions = {
      suppressSizeToFit: true,
      columnDefs: receivablesColumns,
      rowData: this.props.receivableList,
      defaultColDef: defaultColDef,
      rowHeight: 20,
      tooltipShowDelay: 0,
      enableBrowserTooltips: true,
      suppressRowClickSelection: true,
      rowClass: this.getRowClass,
      headerHeight: 25,
    };

    return (
      <div
        className="ag-theme-balham"
        style={{ height: "200px", backgroundColor: "unset" }}
      >
        <AgGridReact {...gridOptions} onGridReady={this.onGridReady} />
      </div>
    );
  }
}
